// ICE (Internal Combustion Engine)
import { createSelector } from 'reselect';

import {
  getVehicleEfficiencyCNG,
  getVehicleEfficiencyDiesel,
  getVehicleEfficiencyGasoline,
} from '../../vehicleEfficiency';


// Get ICE Fuel-Type Specific Emission Rates
// Converts from
// kg CO2/gallon to
// Liters/gm
const co2PerGallonToLitersPerGm = (factor: number) => {
  return 3.7 / factor / 1000; // L/gm
}

export const getGasolineEmissionsPerKm = createSelector([
  getVehicleEfficiencyGasoline,
],
  (efficiencySeries) => {
    const GASOLINE_FUEL_EMISSION_FACTOR = 8.78; // kg CO2/gallon
    const emissionFactor = co2PerGallonToLitersPerGm(GASOLINE_FUEL_EMISSION_FACTOR);

    // May get weird numbers if dividing by zero
    return efficiencySeries.map(
      efficiency => {
        return {
          autoRickshaw: {
            commercial: 1 / emissionFactor / efficiency.autoRickshaw.commercial,
          },
          car: {
            commercial: 1 / emissionFactor / efficiency.car.commercial,
            private: 1 / emissionFactor / efficiency.car.private,

          },
          publicTransit: {
            bus: 1 / emissionFactor / efficiency.publicTransit.bus,
          },
          twoWheel: {
            commercial: 1 / emissionFactor / efficiency.twoWheel.commercial,
            private: 1 / emissionFactor / efficiency.twoWheel.private,
          }
        }
      }
    )
  }
)

export const getDieselEmissionsPerKm = createSelector([
  getVehicleEfficiencyDiesel,
],
  (efficiencySeries) => {
    const DIESEL_FUEL_EMISSION_FACTOR = 10.92; // kg CO2/gallon
    const emissionFactor = co2PerGallonToLitersPerGm(DIESEL_FUEL_EMISSION_FACTOR);

    // Will get infinity if you divide by zero
    return efficiencySeries.map(
      efficiency => {
        return {
          autoRickshaw: {
            commercial: 1 / emissionFactor / efficiency.autoRickshaw.commercial,
          },
          car: {
            commercial: 1 / emissionFactor / efficiency.car.commercial,
            private: 1 / emissionFactor / efficiency.car.private,

          },
          publicTransit: {
            bus: 1 / emissionFactor / efficiency.publicTransit.bus,
          }
        }
      }
    )
  }
)

export const getCNGEmissionsPerKm = createSelector([
  getVehicleEfficiencyCNG,
],
  (efficiencySeries) => {
    const CNG_FUEL_EMISSION_FACTOR = 0.054440 * 123.560000; // (kg CO2/scf )* (scf/gge)
    const emissionFactor = co2PerGallonToLitersPerGm(CNG_FUEL_EMISSION_FACTOR);

    return efficiencySeries.map(
      efficiency => {
        return {
          autoRickshaw: {
            commercial: 1 / emissionFactor / efficiency.autoRickshaw.commercial,
          },
          car: {
            commercial: 1 / emissionFactor / efficiency.car.commercial,
            private: 1 / emissionFactor / efficiency.car.private,

          },
          publicTransit: {
            bus: 1 / emissionFactor / efficiency.publicTransit.bus,
          }
        }
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/store/selectors/carbonPollution/carbonEmissionRate/ice.ts